export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL = "/medstry-logo.png";

export const NAV_ITEMS = [
  { label: "Solutions", href: "/#solutions" },
  { label: "Approach", href: "/approach" },
  { label: "Impact", href: "/impact" },
  { label: "About", href: "/about" },
  { label: "Quiz", href: "/quiz" },
  { label: "Resources", href: "/resources" },
  { label: "Contact", href: "/#contact" },
];

export const COMPANY = {
  name: "Medstry Healthcare Pvt Ltd",
  email: "contact@medstry.in",
  phone: "+91-70216-24830",
  address: "BH 1023, Puri 81 Business Hub, Sector 81, Faridabad, Haryana 121002",
  social: {
    linkedin: "https://www.linkedin.com/company/medstry/",
    instagram: "https://www.instagram.com/medstryhealth/",
    facebook: "https://www.facebook.com/medstry",
  },
};

export const METRICS = [
  { value: "55,000+", label: "HCP Touchpoints" },
  { value: "60,000+", label: "Chemist Network" },
  { value: "300+", label: "Market HQs" },
  { value: "40-50%", label: "OPEX Reduction" },
];

export const COMPANY_TYPES = [
  "Large & Leading Pharma",
  "Small/Mid-Size Healthcare Company",
  "Multinational Company (MNC)",
  "OTC / Consumer Healthcare",
  "Other",
];

export const PRIMARY_CHALLENGES = [
  "Low growth or de-growth of mature brands",
  "Urban market share erosion / declining prescriptions",
  "Poor rural / extra-urban penetration",
  "High expiry / return rates or poor stock movement",
  "Limited marketing / promotion budget",
];

export const QUIZ_QUESTIONS = [
  {
    id: "mature_brand_count",
    question: "How many mature/tail-end brands (10+ years) in your portfolio?",
    options: ["0-5", "6-12", "13-20", "21+"],
  },
  {
    id: "revenue_pct",
    question: "What % of your total revenue comes from these brands?",
    options: ["<10%", "10-25%", "26-50%", ">50%"],
  },
  {
    id: "challenge",
    question: "What is your most pressing challenge?",
    options: PRIMARY_CHALLENGES,
  },
  {
    id: "rural_coverage",
    question: "Are you actively covering rural / extra-urban markets today?",
    options: ["Yes", "No"],
  },
  {
    id: "revenue_bucket",
    question: "Combined annual revenue of these mature brands?",
    options: ["10-50", "50-100", "100-300", "300+"],
    suffix: " Cr",
    prefix: "₹",
  },
];

export const IMAGES = {
  heroBackground:
    "https://static.prod-images.emergentagent.com/jobs/40275341-2de0-43f5-924a-936ac18061eb/images/2af05c4fb4e2ada22334bb850e4d61ac82303d8f8825ea0563214c423c974592.png",
  network:
    "https://static.prod-images.emergentagent.com/jobs/40275341-2de0-43f5-924a-936ac18061eb/images/99ffd4f3c8ea4aa3614b4a41f4bbcfb0136f1f607c60c506f3f23bbd7b51457b.png",
  facility:
    "https://static.prod-images.emergentagent.com/jobs/40275341-2de0-43f5-924a-936ac18061eb/images/75fc89b83a07030330fd9f7c570228a5e7b7c84347775c0d85a4412467b9afd9.png",
  leadership:
    "https://images.unsplash.com/photo-1659353220660-710d4c28c673?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBjb3Jwb3JhdGUlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzc3NTY0NzUwfDA&ixlib=rb-4.1.0&q=85",
  meeting:
    "https://static.prod-images.emergentagent.com/jobs/40275341-2de0-43f5-924a-936ac18061eb/images/6880024b2962ff18798b40121ff1c4e0477a294e33120453ab40ff64071d0631.png",
};

// Team / Leadership — founder spotlight only. Broader team described generically.
export const TEAM = [
  {
    name: "Inderjit Sood",
    role: "Co-Founder & Managing Director",
    tenure: "Three decades in Pharma & Healthcare",
    bio: "Healthcare and pharma veteran with three decades of leadership experience across top global MNCs and leading Indian companies. Has held senior commercial and operations roles across multiple therapy areas and brought that experience to founding Medstry — built on the belief that India's mature and tail-end pharma brands are an untapped growth engine.",
    focus: ["Commercial Strategy", "Brand Lifecycle", "Channel Operations"],
  },
];
